import type { SubscriberPreferenceDisplayType } from '~/interfaces/subscriber_preferences';

/**
 * Maps display types from backend to frontend format
 * @param displayType - The display type to map
 * @returns The mapped display type
 */
export const mapDisplayType = (
  displayType: SubscriberPreferenceDisplayType,
): 'radio-buttons' | 'checkboxes' | 'numerals' | 'unstyled' => {
  switch (displayType) {
    case 'radio_buttons':
      return 'radio-buttons';
    case 'checkboxes':
      return 'checkboxes';
    case 'numerals':
      return 'numerals';
    case 'unstyled':
      return 'unstyled';
    default:
      return 'unstyled';
  }
};
